module.exports = require("http");


/*****************
 ** WEBPACK FOOTER
 ** external "http"
 ** module id = 121
 ** module chunks = 0
 **/